"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const utils_1 = require("../utils");
/**
 * Set status of order to HOLD
 * Can only be done when the order is in CANCELLED status
 * @param event
 * @param prevState
 */
function default_1(event, prevState = {}) {
    const order = (0, utils_1.clone)(prevState);
    // can only hold order when order is created
    if (order.status == domain_1.OrderStatus.CREATED) {
        (0, utils_1.updateOrderAndItemsStatus)(order, domain_1.OrderStatus.ON_HOLD, domain_1.OrderItemStatus.ON_HOLD);
    }
    return order;
}
exports.default = default_1;
//# sourceMappingURL=holdOrder.js.map